import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { List, Input, Button } from 'antd'

import Item from './Item'
import AddKeywords from '../AddKeywords'

@inject((store: any) => {
    const { synonymsStore } = store
    return { synonymsStore }
})
@observer
class SynonymList extends Component<any, any> {
    async componentDidMount() {
        const { getSynonymsList, applyFilters, resetFilters } = this.props.synonymsStore
        await getSynonymsList()
        resetFilters()
        applyFilters()
    }
    handleFilterChange = (name, value) => {
        const { applyFilters, addFilter } = this.props.synonymsStore
        addFilter(name, value)
        applyFilters()
    }
    render() {
        const { filteredList, filters, toggleKeywordsEdit, keywordsEdit, pendingKeywords } = this.props.synonymsStore
        return (
            <Fragment>
                {!keywordsEdit && pendingKeywords.length > 0 ? (
                    <div style={{ padding: '0.5rem', margin: '0 0 0.5rem', backgroundColor: '#ffeed5' }}>
                        <h2 style={{ fontSize: '1rem', padding: '0 0.5rem' }}>מושגים ממתינים להוספה</h2>
                        <AddKeywords />
                    </div>
                ) : (
                    ''
                )}
                <Input.Search
                    placeholder="חפש מושגים נרדפים בקבוצות"
                    style={{ margin: '0rem 0 0.4rem' }}
                    value={filters['freeSearch']}
                    onChange={e => this.handleFilterChange('freeSearch', e.target.value)}
                />
                <Button
                    style={{ margin: '0.4rem 0' }}
                    type={keywordsEdit === 'ADD' ? 'default' : 'primary'}
                    onClick={() => toggleKeywordsEdit('ADD')}
                >
                    {keywordsEdit === 'ADD' ? 'בטל הוספה' : 'הוסף קבוצה חדשה +'}
                </Button>
                {keywordsEdit === 'ADD' && <Item key="ADD" synonymItem={{ id: 'ADD', weight: 1 }} />}
                <List
                    dataSource={filteredList}
                    pagination={{
                        pageSize: 10
                    }}
                    renderItem={item => {
                        return (
                            <List.Item style={{ padding: '0', flexDirection: 'column' }}>
                                <Item key={item['id']} synonymItem={item} />
                            </List.Item>
                        )
                    }}
                />
            </Fragment>
        )
    }
}

export default withRouter(SynonymList)
